import React from 'react';
import { CheckCircle, XCircle, AlertTriangle, Info } from './icons';

const ICONS = {
  success: { Icon: CheckCircle   },
  error:   { Icon: XCircle       },
  warning: { Icon: AlertTriangle },
  info:    { Icon: Info          },
};

const ToastIcon = ({ type }) => {
  const { Icon } = ICONS[type] || ICONS.info;
  return (
    <div className={`toast-icon toast-icon--${type || 'info'}`}>
      <Icon size={15} color="#fff" strokeWidth={2.5} />
    </div>
  );
};

export default ToastIcon;
